/* eslint-disable */
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import React, { useRef, useCallback, useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Ratings from "../ChatActions/Ratings/Ratings";
import { clearSupportMessage, supportSocketEmit } from "../../actions/support";
import styles from "./ChatMessagesHistory.module.scss";
import Highlight from "../ChatActions/Search/Highlight";
import Timestamp from "../ChatActions/Timestamp/Timestamp";
import Swal from "sweetalert2";
import moment from "moment";
import { getPresignedUrlView } from "../../utils/files";
import Popup from "reactjs-popup";
import { LinkifiedText } from "../../utils/linkify";
import {
  formatDualCurrency,
  getOfferDualAmountsWithBase,
  inferOfferBaseCurrency,
  getBaseCurrencyBySwitchDate,
  getDisplayCurrencyOrderBySwitchDate,
  getDualAmountsFromBase,
} from "../../utils/currency";

const payment_messages_to_exclude = ["651555104e3ce3152db7e2d3"];

function ChatMessagesHistory({
  messages,
  supportSocketEmit,
  nextPage,
  searchTags,
  setMatches,
  hasNextPage,
  slug,
  setReplyAction,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { topicId } = useParams();
  const { messageToBeScrolled } = useSelector(({ support }) => support);
  const observer = useRef(null);
  const [canceled, setCanceled] = useState(false);
  const [imageUrls, setImageUrls] = useState({});
  const [showReplyButton, setShowReplyButton] = useState({
    open: false,
    _id: null,
  });
  const loggedOfferIdsRef = useRef(new Set());
  const loggedPaymentIdsRef = useRef(new Set());

  const handleLoadMessagesRef = useCallback(
    (node) => {
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting === true && hasNextPage === true) {
          //nextPage < totalPages
          const event = {
            action: "nextMessages",
            payload: {
              ticket: topicId,
              pageSize: 20,
              pageNumber: nextPage,
            },
          };
          supportSocketEmit(event);
        }
      });
      if (node) observer.current.observe(node);
    },
    [nextPage]
  );

  useEffect(() => {
    if (slug !== "61ee8b87a07ddf1eb8268265") return;
    const fetchPresignedUrls = async () => {
      const urls = {};
      for (const message of messages) {
        if (
          message?.variant !== "text" &&
          message?.variant !== "vote" &&
          message?.variant !== "payment" &&
          message?.variant !== "offer" &&
          (message?.text?.startsWith("https://amarant2.s3") ||
            message?.text?.startsWith("https://amarant-rpa.s3") ||
            message?.text?.startsWith("https://amarant-docs.s3"))
        ) {
          try {
            const url = await getPresignedUrlView(message.text);
            urls[message._id] = url;
          } catch (error) {
            console.error(
              `Error fetching presigned URL for message ${message._id}`,
              error
            );
          }
        }
      }
      setImageUrls(urls);
    };
    if (messages?.length > 0) {
      fetchPresignedUrls();
    }
  }, [messages]);

  useEffect(() => {
    messages?.forEach((message) => {
      if (message?.variant === "offer" && message?.offer?._id) {
        if (!loggedOfferIdsRef.current.has(message.offer._id)) {
          loggedOfferIdsRef.current.add(message.offer._id);
          const offerBaseCurrency = inferOfferBaseCurrency(
            message?.offer,
            message?.createdAt ? new Date(message.createdAt) : new Date()
          );
          console.log("[Offer][chat] offer message", {
            message: message,
            messageId: message?._id,
            offerId: message?.offer?._id,
            hasBgn: Boolean(message?.offer?.bgn),
            offerBaseCurrency,
            insuranceSum: message?.offer?.insuranceSum,
            premium: message?.offer?.premium,
            originalPremium: message?.offer?.originalPremium,
            bgnInsuranceSum: message?.offer?.bgn?.insuranceSum,
            bgnPremium: message?.offer?.bgn?.premium,
            bgnOriginalPremium: message?.offer?.bgn?.originalPremium,
          });
        }
      }

      if (message?.variant === "payment" && message?._id) {
        if (!loggedPaymentIdsRef.current.has(message._id)) {
          loggedPaymentIdsRef.current.add(message._id);
          const createdAt = message?.createdAt ? new Date(message.createdAt) : null;
          const rawAmount = message?.metaData?.amount;
          const amount = rawAmount ? rawAmount / 100 : null;
          const baseCurrency = createdAt
            ? getBaseCurrencyBySwitchDate(createdAt)
            : null;
          const displayOrder = createdAt
            ? getDisplayCurrencyOrderBySwitchDate(createdAt)
            : null;
          const dual = baseCurrency
            ? getDualAmountsFromBase(amount, baseCurrency)
            : null;
          console.log("[Payment][chat] payment message", {
            messageId: message?._id,
            createdAt: createdAt?.toISOString?.() || message?.createdAt,
            rawAmount,
            amount,
            baseCurrency,
            displayOrder,
            dualDisplay:
              dual && displayOrder ? formatDualCurrency(dual, displayOrder) : null,
            status: message?.metaData?.status,
            paymentCanceled: message?.paymentCanceled,
          });
        }
      }
    });
  }, [messages]);

  const handleScrollToRepliedMessage = (_id) => {
    const foundMessage = document.getElementById(_id);
    if (foundMessage) foundMessage.scrollIntoView({ behavior: "smooth" });
    else {
      localStorage.setItem("scrollToMessage", _id);
      supportSocketEmit({
        action: "nextMessages",
        payload: {
          noPagination: true,
          ticket: topicId,
        },
      });
    }
  };

  useEffect(() => {
    if (messageToBeScrolled) handleScrollToRepliedMessage(messageToBeScrolled);
    dispatch(clearSupportMessage());
  }, [messageToBeScrolled]);
  return (
    <div className={styles["messages-container"]}>
      {messages && messages.length > 0 && (
        <div className={styles["timestamp-container"]}>
          <Timestamp time={messages[messages.length - 1]?.createdAt} />
        </div>
      )}

      {messages
        ?.slice()
        .reverse()
        .map((message, index, reversedArr) => {
          // Calculate the original index for comparison
          const originalMessages = messages;
          const originalIndex = originalMessages.length - 1 - index;

          // Add date header for date changes (comparing with the previous message in original order)
          const showDateHeader =
            index > 0 &&
            format(new Date(message?.createdAt), "dd.MM.yyyy") !==
              format(new Date(reversedArr[index - 1]?.createdAt), "dd.MM.yyyy");

          return (
            <React.Fragment key={message?._id}>
              {showDateHeader && (
                <div className={styles["timestamp-container"]}>
                  <Timestamp time={message?.createdAt} />
                </div>
              )}

              <div
                ref={handleLoadMessagesRef}
                className={`${styles.message} ${
                  message?.type !== "Customer" ? styles.me : ""
                }`}
                id={message?._id}
                onMouseEnter={() => {
                  if (slug === "61ee8b87a07ddf1eb8268265")
                    setShowReplyButton({ open: true, _id: message?._id });
                }}
                onMouseLeave={() => {
                  if (slug === "61ee8b87a07ddf1eb8268265")
                    setShowReplyButton({ open: false, _id: null });
                }}
              >
                {message?.variant == "payment" && (
                  <>
                    <p className={styles.time}>
                      {format(new Date(message?.createdAt), "HH:mm")}
                    </p>
                    <div
                      className={styles["message-body"]}
                      style={{ textAlign: "end" }}
                    >
                      <Highlight setMatches={setMatches} tags={searchTags}>
                        <p>{t("chat:paymentInitiated")}</p>
                        <p>
                          {t("chat:amount")}{" "}
                          <b>
                            {formatDualCurrency(
                              getDualAmountsFromBase(
                                message?.metaData?.amount
                                  ? message?.metaData?.amount / 100
                                  : null,
                                getBaseCurrencyBySwitchDate(
                                  new Date(message?.createdAt)
                                )
                              ),
                              getDisplayCurrencyOrderBySwitchDate(
                                new Date(message?.createdAt)
                              )
                            )}
                          </b>
                        </p>
                        <p>
                          {t("chat:basis")} <b>{message?.text}</b>
                        </p>
                        <p>
                          {t("chat:statusLabel")}{" "}
                          <b
                            className={`${styles["status"]} ${
                              message?.metaData?.status === "paid" ||
                              payment_messages_to_exclude.includes(message?._id)
                                ? styles["green"]
                                : null
                            }`}
                          >
                            {message?.paymentCanceled === true
                              ? t("chat:cancelled")
                              : message?.metaData?.status === "paid" ||
                                payment_messages_to_exclude.includes(
                                  message?._id
                                )
                              ? t("chat:paid")
                              : t("chat:unpaid")}
                          </b>
                        </p>
                      </Highlight>
                    </div>
                    {message?.paymentCanceled === false &&
                    message?.metaData?.status !== "paid" &&
                    !payment_messages_to_exclude.includes(message?._id) ? (
                      <div
                        className={styles["deletePayment"]}
                        onClick={() => {
                          supportSocketEmit({
                            action: "cancelPayment",
                            payload: {
                              message: message?._id,
                            },
                          });

                          const event = {
                            action: "nextMessages",
                            payload: {
                              ticket: topicId,
                              pageSize: 200,
                              pageNumber: nextPage - 1,
                            },
                          };
                          supportSocketEmit(event);
                          Swal.fire(
                            t("chat:paymentCancelled"),
                            "",
                            "success"
                          );
                          setCanceled(true);
                        }}
                      >
                        <div className={styles["bin"]} />
                        <b style={{ color: "#8244EB" }}>{t("chat:cancelPayment")}</b>
                      </div>
                    ) : null}
                    {messages?.filter(
                      (mess) =>
                        mess?.type === "User" && mess?.variant === "payment"
                    ).length &&
                    (message?.metaData?.status === "paid" ||
                      payment_messages_to_exclude.includes(message?._id)) ? (
                      <div
                        className={styles["deletePayment"]}
                        onClick={() =>
                          navigate(
                            `/addPolicyToUser/${topicId}/${
                              message?.metaData?.customerSupportPayment
                                ?.customerSupportId
                            }/${
                              messages?.filter(
                                (mess) =>
                                  mess?.variant === "offer" &&
                                  mess?.offer?.accepted
                              )?.length
                                ? messages?.filter(
                                    (mess) =>
                                      mess?.variant === "offer" &&
                                      mess?.offer?.accepted
                                  )?.[0]?.offer?._id
                                : "no-offer"
                            }`
                          )
                        }
                      >
                        <div className={styles["add-policy"]} />
                        <b style={{ color: "#01D088" }}>
                          {t("chat:addPolicyToProfile")}
                        </b>
                      </div>
                    ) : null}
                  </>
                )}
                {message?.variant == "offer" && (
                  <>
                    {message?.type !== "Customer" && (
                      <p className={styles.time}>
                        {format(new Date(message?.createdAt), "HH:mm")}
                      </p>
                    )}

                    <div
                      className={styles["message-body"]}
                      style={{
                        textAlign: message?.type !== "Customer" && "end",
                      }}
                    >
                      <Highlight setMatches={setMatches} tags={searchTags}>
                        <div
                          style={{
                            margin: "5px 0px",
                            width: "100%",
                            display: "flex",
                            justifyContent: "space-between",
                            flexDirection:
                              message?.type === "Customer" && "row-reverse",
                          }}
                        >
                          {message?.offer?.accepted ? (
                            <p style={{ color: "#01D088", fontSize: "12px" }}>
                              <b>{t("chat:selectedOffer")}</b>
                            </p>
                          ) : (
                            <div
                              className={`${styles["edit-offer-icon"]}`}
                              onClick={() => {
                                navigate(
                                  `/editOffer/${topicId}/${message?.offer?._id}`
                                );
                              }}
                            />
                          )}
                          <b style={{ textTransform: "uppercase" }}>
                            {message?.offer?.insuranceCompanyName}
                          </b>
                        </div>
                        <p style={{ margin: "5px 0px" }}>
                          {t("chat:insuranceSum")}{" "}
                          <b>
                            {formatDualCurrency(
                              getOfferDualAmountsWithBase(
                                message?.offer,
                                "insuranceSum",
                                inferOfferBaseCurrency(
                                  message?.offer,
                                  message?.createdAt
                                    ? new Date(message.createdAt)
                                    : new Date()
                                )
                              ),
                              ["EUR", "BGN"]
                            )}
                          </b>
                        </p>
                        {(() => {
                          const offerBaseCurrency = inferOfferBaseCurrency(
                            message?.offer,
                            message?.createdAt
                              ? new Date(message.createdAt)
                              : new Date()
                          );
                          const originalPremiumAmounts =
                            getOfferDualAmountsWithBase(
                              message?.offer,
                              "originalPremium",
                              offerBaseCurrency
                            );
                          const premiumAmounts = getOfferDualAmountsWithBase(
                            message?.offer,
                            "premium",
                            offerBaseCurrency
                          );
                          const originalPremiumEur = Number(
                            originalPremiumAmounts?.EUR || 0
                          );
                          const premiumEur = Number(premiumAmounts?.EUR || 0);

                          if (originalPremiumAmounts?.EUR) {
                            const discountEur = originalPremiumEur - premiumEur;
                          const discountAmounts = {
                            EUR: discountEur,
                            BGN:
                              (originalPremiumAmounts?.BGN ?? null) === null ||
                              (premiumAmounts?.BGN ?? null) === null
                                ? null
                                : originalPremiumAmounts.BGN -
                                  premiumAmounts.BGN,
                          };
                            return (
                              <>
                                <p style={{ margin: "5px 0px" }}>
                                  {t("chat:premiumBeforeDiscount")}{" "}
                                  <b>
                                    {formatDualCurrency(
                                      originalPremiumAmounts,
                                      ["EUR", "BGN"]
                                    )}
                                  </b>
                                </p>
                                <p style={{ margin: "5px 0px" }}>
                                  {t("chat:discountLabel")}{" "}
                                  <b>
                                    {formatDualCurrency(discountAmounts, [
                                      "EUR",
                                      "BGN",
                                    ])}{" "}
                                    {`(${Math.round(
                                      100 - (premiumEur / originalPremiumEur) * 100
                                    )} %)`}
                                  </b>
                                </p>
                                <p style={{ margin: "5px 0px" }}>
                                  {t("chat:premiumAfterDiscount")}{" "}
                                  <b>
                                    {formatDualCurrency(premiumAmounts, [
                                      "EUR",
                                      "BGN",
                                    ])}
                                  </b>
                                </p>
                              </>
                            );
                          }

                          return (
                            <p style={{ margin: "5px 0px" }}>
                              {t("chat:premium")}{" "}
                              <b>
                                {formatDualCurrency(premiumAmounts, [
                                  "EUR",
                                  "BGN",
                                ])}
                              </b>
                            </p>
                          );
                        })()}

                        <p style={{ margin: "5px 0px" }}>
                          {t("chat:installmentN", { n: 1 })}{" "}
                          <b>
                            {formatDualCurrency(
                              getOfferDualAmountsWithBase(
                                message?.offer,
                                "installmentOneSum",
                                inferOfferBaseCurrency(
                                  message?.offer,
                                  message?.createdAt
                                    ? new Date(message.createdAt)
                                    : new Date()
                                )
                              ),
                              ["EUR", "BGN"]
                            )}
                          </b>
                        </p>
                        <p style={{ margin: "5px 0px" }}>
                          {t("chat:installmentN", { n: 2 })}{" "}
                          <b>
                            {Number(message?.offer?.installmentsCount) >= 2
                              ? formatDualCurrency(
                                  getOfferDualAmountsWithBase(
                                    message?.offer,
                                    "installmentTwoSum",
                                    inferOfferBaseCurrency(
                                      message?.offer,
                                      message?.createdAt
                                        ? new Date(message.createdAt)
                                        : new Date()
                                    )
                                  ),
                                  ["EUR", "BGN"]
                                )
                              : "---"}
                          </b>
                        </p>
                        <p style={{ margin: "5px 0px" }}>
                          {t("chat:installmentN", { n: 3 })}{" "}
                          <b>
                            {Number(message?.offer?.installmentsCount) >= 3
                              ? formatDualCurrency(
                                  getOfferDualAmountsWithBase(
                                    message?.offer,
                                    "installmentThreeSum",
                                    inferOfferBaseCurrency(
                                      message?.offer,
                                      message?.createdAt
                                        ? new Date(message.createdAt)
                                        : new Date()
                                    )
                                  ),
                                  ["EUR", "BGN"]
                                )
                              : "---"}
                          </b>
                        </p>
                        <p style={{ margin: "5px 0px" }}>
                          {t("chat:installmentN", { n: 4 })}{" "}
                          <b>
                            {Number(message?.offer?.installmentsCount) >= 4
                              ? formatDualCurrency(
                                  getOfferDualAmountsWithBase(
                                    message?.offer,
                                    "installmentFourSum",
                                    inferOfferBaseCurrency(
                                      message?.offer,
                                      message?.createdAt
                                        ? new Date(message.createdAt)
                                        : new Date()
                                    )
                                  ),
                                  ["EUR", "BGN"]
                                )
                              : "---"}
                          </b>
                        </p>
                      </Highlight>
                    </div>
                    {message?.type === "Customer" && (
                      <p className={styles.time}>
                        {format(new Date(message?.createdAt), "HH:mm")}
                      </p>
                    )}
                    <p
                      className={`${styles["message-status"]} ${
                        message?.readByCustomer === true && styles["green"]
                      }`}
                    >
                      {message?.type.includes("User") &&
                      index === messages.length - 1
                        ? message?.readByCustomer === true
                          ? t("chat:readAt", {
                              time: moment(
                                message?.readByCustomerDate
                              ).format("HH:mm"),
                            })
                          : t("chat:delivered")
                        : null}
                    </p>
                  </>
                )}
                {message?.variant == "vote" && <Ratings message={message} />}

                {message?.variant !== "text" &&
                message?.variant !== "vote" &&
                message?.variant !== "payment" &&
                message?.variant !== "offer" ? (
                  <>
                    {message?.type !== "Customer" && (
                      <p className={styles.time}>
                        {format(new Date(message?.createdAt), "HH:mm")}
                      </p>
                    )}
                    {message?.variant === "photo" ? (
                      <div
                        className={`${styles["photo-message"]}`}
                        style={{
                          backgroundImage: imageUrls[message._id]
                            ? `url(${imageUrls[message._id]})`
                            : `url(${message?.text})`,
                          backgroundPosition:
                            message?.type === "Customer" ? "left" : "right",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          window.open(imageUrls[message._id] || message?.text)
                        }
                      />
                    ) : (
                      <a
                        className={`${styles["message-body"]} ${styles.media}`}
                        href={imageUrls[message._id] || message?.text}
                        download={imageUrls[message._id] || message?.text}
                        target="_blank"
                        style={{ wordBreak: "break-word", cursor: "pointer" }}
                      >
                        {message?.text}
                      </a>
                    )}

                    {message?.type === "Customer" && (
                      <p className={styles.time}>
                        {format(new Date(message?.createdAt), "HH:mm")}
                      </p>
                    )}
                    <p
                      className={`${styles["message-status"]} ${
                        message?.readByCustomer === true && styles["green"]
                      }`}
                    >
                      {message?.type.includes("User") && originalIndex === index
                        ? message?.readByCustomer === true
                          ? t("chat:readAt", {
                              time: moment(
                                message?.readByCustomerDate
                              ).format("HH:mm"),
                            })
                          : t("chat:delivered")
                        : null}
                    </p>
                  </>
                ) : (
                  <>
                    {message?.variant !== "vote" &&
                    message?.variant !== "payment" &&
                    message?.variant !== "offer" ? (
                      <>
                        {message?.type !== "Customer" ? (
                          <>
                            {message?.variant === "text" &&
                              message?.replyToMessage && (
                                <div
                                  className={` ${styles["reply-container"]} ${
                                    message?.type !== "Customer" &&
                                    styles["reversed"]
                                  }`}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div className={styles["reply-icon"]} />
                                    <p style={{ fontStyle: "italic" }}>
                                      {t("chat:replyToMessageTitle")}
                                    </p>
                                  </div>
                                  <div
                                    className={styles["reply-message"]}
                                    onClick={() =>
                                      handleScrollToRepliedMessage(
                                        message?.replyToMessage?._id
                                      )
                                    }
                                  >
                                    {message?.replyToMessage?.text?.length > 40
                                      ? message?.replyToMessage?.text?.slice(
                                          0,
                                          40
                                        ) + "..."
                                      : message?.replyToMessage?.text}
                                  </div>
                                </div>
                              )}
                            <p className={styles.sender}>
                              {message?.from?.name}
                            </p>
                            {message?.variant === "text" &&
                              showReplyButton.open &&
                              showReplyButton._id === message?._id &&
                              slug === "61ee8b87a07ddf1eb8268265" && (
                                <Popup
                                  trigger={
                                    <div
                                      className={styles["reply-menu-icon"]}
                                    />
                                  }
                                >
                                  {(close) => (
                                    <div
                                      className={styles["reply-button"]}
                                      onClick={() => {
                                        setReplyAction({
                                          open: true,
                                          message: message,
                                        });
                                        close();
                                      }}
                                    >
                                      <div className={styles["reply-icon"]} />
                                      <p>{t("chat:reply")}</p>
                                    </div>
                                  )}
                                </Popup>
                              )}
                            <div className={styles.time}>
                              {format(new Date(message?.createdAt), "HH:mm")}
                            </div>
                            <div className={styles["message-body"]}>
                              <Highlight
                                setMatches={setMatches}
                                tags={searchTags}
                              >
                                <LinkifiedText text={message?.text} />
                              </Highlight>
                            </div>

                            <p
                              className={`${styles["message-status"]} ${
                                message?.readByCustomer === true &&
                                styles["green"]
                              }`}
                            >
                              {message?.type.includes("User") &&
                              index === messages.length - 1
                                ? message?.readByCustomer === true
                                  ? t("chat:readAt", {
                                      time: moment(
                                        message?.readByCustomerDate
                                      ).format("HH:mm"),
                                    })
                                  : t("chat:delivered")
                                : null}
                            </p>
                          </>
                        ) : (
                          <>
                            {message?.variant === "text" &&
                              message?.replyToMessage &&
                              slug === "61ee8b87a07ddf1eb8268265" && (
                                <div
                                  className={` ${styles["reply-container"]} ${
                                    message?.type !== "Customer" &&
                                    styles["reversed"]
                                  }`}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div className={styles["reply-icon"]} />
                                    <p style={{ fontStyle: "italic" }}>
                                      {t("chat:replyToMessageTitle")}
                                    </p>
                                  </div>
                                  <div
                                    className={styles["reply-message"]}
                                    onClick={() =>
                                      handleScrollToRepliedMessage(
                                        message?.replyToMessage?._id
                                      )
                                    }
                                  >
                                    {message?.replyToMessage?.text?.length > 40
                                      ? message?.replyToMessage?.text?.slice(
                                          0,
                                          40
                                        ) + "..."
                                      : message?.replyToMessage?.text}
                                  </div>
                                </div>
                              )}
                            <p className={styles.sender}>
                              {message?.from?.name}
                            </p>
                            <div className={styles["message-body"]}>
                              <Highlight
                                setMatches={setMatches}
                                tags={searchTags}
                              >
                                <LinkifiedText text={message?.text} />
                              </Highlight>
                            </div>
                            <p className={styles.time}>
                              {format(new Date(message?.createdAt), "HH:mm")}
                            </p>
                            {message?.variant === "text" &&
                              showReplyButton.open &&
                              showReplyButton._id === message?._id &&
                              slug === "61ee8b87a07ddf1eb8268265" && (
                                <Popup
                                  trigger={
                                    <div
                                      className={styles["reply-menu-icon"]}
                                    />
                                  }
                                >
                                  {(close) => (
                                    <div
                                      className={styles["reply-button"]}
                                      onClick={() => {
                                        setReplyAction({
                                          open: true,
                                          message: message,
                                        });
                                        close();
                                      }}
                                    >
                                      <div className={styles["reply-icon"]} />
                                      <p>{t("chat:reply")}</p>
                                    </div>
                                  )}
                                </Popup>
                              )}
                          </>
                        )}
                      </>
                    ) : null}
                  </>
                )}
              </div>
            </React.Fragment>
          );
        })}
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({
  supportSocketEmit: (payload) => dispatch(supportSocketEmit(payload)),
});

export default connect(null, mapDispatchToProps)(ChatMessagesHistory);
